import {
    FormattedMessageWithTooltipHeaderRenderer,
    gridNumberFormatter,
    formattedNumberValueGetter,
} from '../../../components';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import EMPTY_FIELD_VALUE from '../../defaultValues';
import * as FIELDS from '../../fields';
import { ATTRIBUTION_GROUP_REPORT_ID } from './attributionGroupReportId';

const attributionGroupReportColumnDefinition = [
    {
        headerName: FIELDS.ATTRIBUTION_GROUP.label,
        field: FIELDS.ATTRIBUTION_GROUP.field,
        type: [leftPinnedColumn],
        valueFormatter: ({ value }) => value || EMPTY_FIELD_VALUE,
    },
    ...[
        FIELDS.SPENT,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.CLICKS,
        FIELDS.VCTR,
        FIELDS.AVERAGE_CPC,
        FIELDS.CVR,
        FIELDS.CONVERSIONS,
        FIELDS.CPA,
        FIELDS.VCPM,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        cellRenderer: fieldConfig.cellRenderer,
        valueFormatter: !fieldConfig.cellRenderer && gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(attributionGroupReportColumnDefinition, ATTRIBUTION_GROUP_REPORT_ID);
